import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  static targets = ["select"];
  static values = { selector: String };
  connect() {
    this.initializeTomSelect();
  }

  initializeTomSelect() {
    const options = {
      plugins: ["remove_button"],
      onChange: (value) => {
        if (this.hasSelectTarget) {
          this.selectTarget.value = value;
        }
      },
    };

    new TomSelect(`#${this.selectorValue}`, options);
  }
}
